import axios from "axios";
import { MessageParameters } from "app/api/types";
import config from "app/api/axiosConfig";

export default (token: string, message: MessageParameters ) =>
	axios.put(`${process.env.REACT_APP_CHAT_HOST}/Api/Messages`, message, config(token))
